import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryActive } from '../../styles/colors';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	tag: {
		alignItems: 'center',
		background: 'transparent',
		border: `1px solid ${brandPrimary}`,
		borderRadius: 9999,
		boxSizing: 'border-box',
		color: brandPrimary,
		cursor: 'pointer',
		display: 'inline-flex',
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xxs,
		gap: THEME.spacing.xs,
		justifyContent: 'center',
		overflow: 'hidden',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		width: 'fit-content',
		':has(*) > svg': {
			display: 'block',
			pointerEvents: 'none',
			width: 10,
			height: 10,
		},
		':hover': {
			borderColor: brandPrimaryActive,
			color: brandPrimaryActive,
		},
	},
	tooltipContent: {
		maxWidth: 200,
		whiteSpace: 'normal',
		wordWrap: 'break-word',
	},
});
